let version: string = '';
let disable: boolean = false;

export const setStimsonConfig = (config: { version: string; disable: boolean }) => {
  version = config.version;
  disable = config.disable || false;
};

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

export async function fetchStimson<ReturnType>(options?: RequestInit): Promise<ReturnType | void> {
  if (version && !disable) {
    const url = `/ejrebooking/api/v${version}/corefunnel/setpodstickiness`;
    // We need to read the XSRF cookie every time and not initialise it once on startup
    // since the XSRF token is unique to each basket session and will update when a basket session expires or user creates a new basket
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...defaultHeaders,
          ...options?.headers
        }
      });

      if (response.headers.has('content-type') && response.headers.get('content-type') === 'application/json') {
        const data = await response.json();
        if (data.error || data.errors) {
          throw data.error || data.errors;
        }
        return data;
      }
    } catch (e) {
      console.error('Stimson fetch error:', e instanceof Error ? e.message : JSON.stringify(e));
    }
  }
}
